export default "__VITE_ASSET__CiZs9RNs__"